import { render } from "./CatMaterialForm.vue?vue&type=template&id=6a3d2078&scoped=true"
import script from "./CatMaterialForm.vue?vue&type=script&lang=js"
export * from "./CatMaterialForm.vue?vue&type=script&lang=js"

import "./CatMaterialForm.vue?vue&type=style&index=0&id=6a3d2078&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3d2078"]])

export default __exports__